var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeaderHoverChecknft = function SvgIconHeaderHoverChecknft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M16.8 2.4h-12a2.37 2.37 0 0 0-2.4 2.4v12c0 1.35 1.05 2.4 2.4 2.4h6.9c-.6-.825-.9-1.875-.9-3v-.6c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6s.6.3.6.6v2.325c.6-1.2 1.725-2.175 3-2.625V6.6c0-.3.3-.6.6-.6s.6.3.6.6v4.275h.6c1.125 0 2.175.3 3 .9V4.8c0-1.35-1.05-2.4-2.4-2.4M7.2 15c0 .3-.3.6-.6.6S6 15.3 6 15V9c0-.3.3-.6.6-.6s.6.3.6.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "m22.65 21.75-3.075-3c1.35-1.875.975-4.5-.825-5.85-1.875-1.425-4.5-.975-5.85.825-1.425 1.875-.975 4.5.825 5.85.75.525 1.575.825 2.475.825.975 0 1.8-.3 2.55-.825l3.075 3.075c.225.225.6.225.825 0 .225-.3.225-.675 0-.9M16.2 19.2c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3"
  })));
};
export default SvgIconHeaderHoverChecknft;